import { t } from 'i18next'

export const actions = {
  update: t('rm:constants.updated'),
  create: t('rm:constants.created'),
  delete: t('rm:constants.deleted')
} as { [key in ResponseGetAuditLogActions]: string }

/** Verbs that replace the global ones for a given entity */
export const actionsByEntity = {
  campaign_checking_account: {
    create: t('rm:constants.linked'),
    delete: t('rm:constants.unlinked')
  }
} as {
  [key in ResponseGetAuditLogEntities]?: {
    [key in ResponseGetAuditLogActions]?: string
  }
}

export const entities = {
  campaign: t('rm:campaign'),
  ad: t('rm:ad'),
  campaign_keyword: t('rm:keyword'),
  campaign_category: t('rm:category'),
  campaign_subpublisher: t('rm:publisher'),
  campaign_checking_account: t('rm:campaign'),
  campaign_destination_url: t('rm:campaign'),
  network_publishers_campaigns_status: t('rm:campaign')
} as { [key in ResponseGetAuditLogEntities]: string }
